module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "add-template",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('p', [_vm._v("Hoe moet deze nieuwe "), _c('em', [_vm._v("productgroep")]), _vm._v(" heten?")])]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "flex-grow": "0"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-1",
      "label": "Typ hier de naam van de productgroep",
      "id": "testing"
    },
    model: {
      value: (_vm.categoryName),
      callback: function($$v) {
        _vm.categoryName = $$v
      },
      expression: "categoryName"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ed3ebfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/app/AddCategory.vue
// module id = 480
// module chunks = 1